import React from 'react';
import { createGlobalStyle } from 'styled-components';
import ReactModal, { Props } from 'react-modal';

type Ref = ReactModal;

export interface ModalProps extends Props {
  children: any;
}

const TRANSITION_TIME = 350;

const GlobalStyle = createGlobalStyle`
.ReactModal__Body--open,
.ReactModal__Html--open {
  overflow: hidden;
}

.ReactModal__Content.csprLive-content {
  width: 650px;
  left: 50% !important;
  top: 25% !important;
  transform: translate(-50%, -25%);

  position: absolute;
  right: 40px;
  bottom: 40px;
  border: 1px solid #ccc;
  background: #fff;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  border-radius: 4px;
  outline: none;
  padding: 20px;
}

.ReactModal__Overlay.csprLive-overlay {
  z-index: ${({ theme }) => theme.zIndex.modal};
  opacity: 0;
  //added to fix safari bug with z-index
  transform: translate3d(0, 0, 1rem);

  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.75);
}

.ReactModal__Overlay--after-open.csprLive-overlay {
  opacity: 1;
  transition: opacity ${TRANSITION_TIME}ms ease-in-out;
}

.ReactModal__Overlay--before-close.csprLive-overlay {
  opacity: 0;
  transition: opacity ${TRANSITION_TIME}ms ease-in-out;
}
`;

export const Modal = React.forwardRef<Ref, ModalProps>(({ ...props }, ref) => {
  return (
    <>
      <GlobalStyle />
      <ReactModal
        ref={ref}
        {...props}
        className={'csprLive-content'}
        overlayClassName={'csprLive-overlay'}
        closeTimeoutMS={TRANSITION_TIME}
        role="dialog"
        aria-modal="true"
      />
    </>
  );
});

export default Modal;
